import React from "react";

export default function MetricCard({
  title,
  value,
  subtitle,
  borderColor,
}) {
  return (
    <div
      className={"rounded-lg shadow-sm p-4 flex flex-col justify-between bg-accent text-accent-foreground"}
      style={{
        borderLeft: borderColor ? `4px solid ${borderColor}` : undefined,
      }}
    >
      <div>
        <div className="text-sm text-blue-800 font-medium">{title}</div>
        <div className="mt-1 text-2xl font-bold text-foreground">{value}</div>
        {subtitle && (
          <div className="mt-1 text-sm text-muted-foreground">
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );
} 